
// import store from "../store";
// import { toast } from 'react-toastify';
// import Envirnment from "../../util/environment";
// SavebuyCity

import axios from "axios";
import { SavebuyCity } from "./user";
import Web3 from "web3";
import { DEFAULTADDRESS, CITYCONTRACT, USERCONSTRUCT } from '../type'
const web3 = new Web3(Web3.givenProvider || "http://localhost8545");



export const getUserData = (useraccount, mincontract,) => async (dispatch) => {
  if (useraccount && mincontract) {
    dispatch({
      type: DEFAULTADDRESS,
      payload: useraccount
    })
    dispatch({
      type: CITYCONTRACT,
      payload: mincontract
    })



    mincontract.methods.cities(useraccount).call()
      .then((val) => {
        dispatch({
          type: USERCONSTRUCT,
          payload: val
        })
        console.log(val, "this is the value")
      })



  }

}

const URL = window.location.hostname === 'localhost' ? 'http://localhost:8000' : '';
export const BuyCity = (value, zip, citesStatsData, Aut) => async (dispatch, getState) => {

  let getRefAddress = localStorage.getItem("CITY_ADD");
  let getDirectFromUrl;

  let url = window.location.href;

  if (url.includes("?ref=")) {
    let getAddress = url.split("?ref=")[1];
    let final = getAddress.slice(0, 42);
    getDirectFromUrl = final;
  }

  if (getState().UserReducer.contract) {

    try {
      getState().UserReducer.contract.methods.buycity(zip)
        .send({
          from: getState().UserReducer.userWalletAddress,
          gas: 2100000,
          value: value
        }).then((res) => {

          dispatch(SavebuyCity(citesStatsData, Aut))

        }).catch((e) => {
        })
    }
    catch (error) {
      console.error(error)
    }
  }

}


export const IncreaseHealthRank = (value, zip) => async (dispatch, getState) => {


  if (getState().UserReducer.userWalletAddress && getState().UserReducer.contract && value && zip) {
    await getState().UserReducer.contract.methods.increaseHealthRate(zip)
      .send({
        from: getState().UserReducer.userWalletAddress,
        gas: 2100000,
        value: value
      }).then((res) => {
        dispatch(getUserData(getState().UserReducer.userWalletAddress, getState().UserReducer.contract))
      })
  }
}

export const IncreaseEducationRate = (value, zip) => async (dispatch, getState) => {
  //  
  if (getState().UserReducer.userWalletAddress && getState().UserReducer.contract && value && zip) {
    await getState().UserReducer.contract.methods.increaseEducationRate(zip)
      .send({
        from: getState().UserReducer.userWalletAddress,
        gas: 2100000,
        value: value
      }).then((res) => {
        dispatch(getUserData(getState().UserReducer.userWalletAddress, getState().UserReducer.contract))
      })
  }
}

export const IncreaseConstructionRage = (value, zip) => async (dispatch, getState) => {
  //  
  if (getState().UserReducer.userWalletAddress && getState().UserReducer.contract && value && zip) {
    await getState().UserReducer.contract.methods.increaseEducationRate(zip)
      .send({
        from: getState().UserReducer.userWalletAddress,
        gas: 2100000,
        value: value
      }).then((res) => {
        dispatch(getUserData(getState().UserReducer.userWalletAddress, getState().UserReducer.contract))
      })
  }
}



// export const WithDrawStakeEarning = (userWalletAddress) => async (dispatch, getState) => {

//   if (getState().UserReducer.MintContract) {
//     getState().UserReducer.MintContract.methods
//       .withdraw()
//       .send({
//         from: userWalletAddress, gas: 5000000,
//         gasPrice: 30000000000
//       })
//       .then(() => {
//         getUserData(userWalletAddress, getState().UserReducer.MintContract, getState().UserReducer.tokenContract);
//       });

//   }



// };



































